import { render, staticRenderFns } from "./sendResult.vue?vue&type=template&id=7f099a75&scoped=true&"
import script from "./sendResult.vue?vue&type=script&lang=js&"
export * from "./sendResult.vue?vue&type=script&lang=js&"
import style0 from "./sendResult.vue?vue&type=style&index=0&id=7f099a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f099a75",
  null
  
)

export default component.exports